/**
 * Surface Selected Chat
 *
 * Resolves the chat shell used by ChatUI headers and actions.
 *
 * Primary responsibilities:
 * - Preserve explicit chat surfaces by matching the requested chat id
 * - Preserve context-selected chats on non-route ChatUI surfaces
 *
 * Dependencies:
 * - supabase/types
 */

import type { Tables } from '@/supabase/types'

type SurfaceSelectedChatOptions = {
  chatId?: string
  pathname: string | null
  selectedChat: Tables<'chats'> | null
}

export function resolveSurfaceSelectedChat({
  chatId,
  pathname,
  selectedChat
}: SurfaceSelectedChatOptions): Tables<'chats'> | null {
  if (chatId) {
    return selectedChat?.id === chatId ? selectedChat : null
  }

  if (pathname === '/chat') {
    return null
  }

  return selectedChat
}
